import {
  FETCH_ERROR,
  FETCH_START,
  FETCH_SUCCESS,
  INIT_URL,
  SIGNOUT_USER_SUCCESS,
  USER_DATA,
  USER_TOKEN_SET,
  GET_SITES_SUCCESS,
  SIGNIN_USER_SUCCESS,
  SIGNIN_USER_ERROR,
  AUTH_REFRESH_ERROR,
  AUTH_REFRESH_START,
  AUTH_REFRESH_SUCCESS,
  AUTH_BOOTSTRAP_FAILURE,
  AUTH_BOOTSTRAP_REQUEST,
  AUTH_BOOTSTRAP_SUCCESS,
  FETCH_USER_START,
  FETCH_USER_SUCCESS,
  FETCH_USER_ERROR,
  SIGNIN_USER_START,
  SIGNOUT_USER_ERROR,
  SIGNOUT_USER_START,
  SET_USER_ROLE,
  FETCH_USER_ALLOWED_RIS_WITH_MIPS,
  FETCH_USER_ALLOWED_RIS_WITH_MIPS_START,
  FETCH_USER_ALLOWED_RIS_WITH_MIPS_SUCCESS,
  FETCH_USER_ALLOWED_RIS_WITH_MIPS_ERROR,
  VERIFY_OTP_START,
  VERIFY_OTP_ERROR,
  VERIFY_OTP_SUCCESS,
  UPDATE_MIP_DATA,
  SET_USER_SITE,

} from "../../constants/ActionTypes";
import axios from "../../util/axiosConfig";
import uuidv1 from 'uuid/v1';
import { history } from '../store';
import { LOGIN_ERROR } from "../../constants/messages";
import { FETCH_MODALITY_TYPES } from "./common/modality-action";
import { APP_MESSAGE_BROADCAST_CHANNEL } from "../../constants/constants";
import { getErrorMessage } from '../../util/ErrorUtils';
import { GET_USER_SESSION_DATA } from "./userLocalStorageSession";
import { message } from 'antd';
import { getUserAllowedRisWithMipsAPI } from "../../services/users-service";
import { verifyOtpAPI } from "../../services/auth.service";
import { navigateTo } from "../../util/navigationService";
export const NEW_SESSION_CREATED = 'NEW_SESSION_CREATED';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';

const getSelectedRoleKey = (email) => `selectedRole:${email}`;
const getSelectedSiteKey = (email) => `selectedSite:${email}`;
const getUserMipsKey = (email) => `userMips:${email}`;
const getAuthContextKey = (email) => `authContext:${email}`;

const readJson = (value, fallback) => {
  try {
    return value ? JSON.parse(value) : fallback;
  } catch (error) {
    return fallback;
  }
};

const clearAuthSession = (authUser) => {
  sessionStorage.removeItem("user");
  sessionStorage.removeItem("mips");
  sessionStorage.removeItem("modalityTypes");
  sessionStorage.removeItem("USESSIONID");
  if (authUser?.email) {
    localStorage.removeItem(authUser.email);
    localStorage.removeItem(getSelectedRoleKey(authUser.email));
    localStorage.removeItem(getSelectedSiteKey(authUser.email));
    localStorage.removeItem(getUserMipsKey(authUser.email));
    localStorage.removeItem(getAuthContextKey(authUser.email));
  }
  if (localStorage.getItem("filterSettings")) {
    localStorage.removeItem("filterSettings");
  }
  if (localStorage.getItem("aptFilterSettings")) {
    localStorage.removeItem("aptFilterSettings");
  }
};

const getRoleName = (role) => (
  typeof role === "string" ? role : role?.name || role?.role || role?.authority
);

const getMipFromItem = (item) => {
  if (!item) return [];
  if (Array.isArray(item)) return item.flatMap(getMipFromItem);
  if (Array.isArray(item.mips)) return item.mips.flatMap(getMipFromItem);
  if (Array.isArray(item.userMips)) return item.userMips.flatMap(getMipFromItem);
  if (Array.isArray(item.risUserMips)) return item.risUserMips.flatMap(getMipFromItem);
  if (item.mip) return getMipFromItem(item.mip);
  if (item.mipId) return [item];
  return [];
};

const getMipsFromAuthData = (data) => {
  const mips = [
    ...getMipFromItem(data.mips),
    ...getMipFromItem(data.userMips),
    ...getMipFromItem(data.risUserMips),
    ...getMipFromItem(data.risWithMips),
    ...getMipFromItem(data.allowedRisWithMips),
  ];
  const uniqueMips = [];
  mips.forEach((mip) => {
    if (mip?.mipId && !uniqueMips.some((existingMip) => existingMip.mipId === mip.mipId)) {
      uniqueMips.push(mip);
    }
  });
  return uniqueMips;
};

const getStoredAuthContext = (email) => {
  const sessionUser = readJson(sessionStorage.getItem("user"), null);
  if (sessionUser && (!email || sessionUser.email === email)) {
    return sessionUser;
  }
  return email ? readJson(localStorage.getItem(getAuthContextKey(email)), null) : null;
};

const mergeByMipId = (...mipLists) => {
  const uniqueMips = [];
  mipLists.flat().forEach((mip) => {
    if (mip?.mipId && !uniqueMips.some((existingMip) => existingMip.mipId === mip.mipId)) {
      uniqueMips.push(mip);
    }
  });
  return uniqueMips;
};

const buildAuthUser = (data, includeAuthenticated = true, storedUser = null) => {
  const roles = data.roles && data.roles.length ? data.roles : (storedUser?.roles || []);
  const email = data.email || storedUser?.email;
  const restoredMips = email ? readJson(localStorage.getItem(getUserMipsKey(email)), []) : [];
  const mips = mergeByMipId(
    getMipsFromAuthData(data),
    storedUser?.mips || [],
    restoredMips
  );
  const userMips = mips.length ? mips : restoredMips;
  const storedRole = email ? localStorage.getItem(getSelectedRoleKey(email)) : null;
  const storedSite = email ? readJson(localStorage.getItem(getSelectedSiteKey(email)), null) : null;
  const role = data.role
    || storedUser?.role
    || (roles.some((role) => getRoleName(role)?.toUpperCase() === storedRole?.toUpperCase()) ? storedRole : null);
  const site = data.site
    || storedUser?.site
    || (userMips.some((mip) => mip.mipId === storedSite?.mipId) ? storedSite : null);

  return {
    ...storedUser,
    ...data,
    ...(includeAuthenticated ? { authenticated: data.authenticated !== false } : {}),
    created_at: new Date(),
    email_verified_at: null,
    email,
    role: role || (roles.length === 1 ? getRoleName(roles[0]) : null),
    site: site || userMips[0] || null,
    updated_at: new Date(),
    roles,
    mips: userMips,
    userMips: data.userMips || storedUser?.userMips,
    risUserMips: data.risUserMips || storedUser?.risUserMips,
    risWithMips: data.risWithMips || storedUser?.risWithMips,
    allowedRisWithMips: data.allowedRisWithMips || storedUser?.allowedRisWithMips,
  };
};

const persistAuthUserContext = (user) => {
  sessionStorage.setItem("user", JSON.stringify(user));
  sessionStorage.setItem("mips", JSON.stringify(user.mips || []));
  if (user.email) {
    localStorage.setItem(getAuthContextKey(user.email), JSON.stringify(user));
    localStorage.setItem(getUserMipsKey(user.email), JSON.stringify(user.mips || []));
    if (user.role) {
      localStorage.setItem(getSelectedRoleKey(user.email), user.role);
    }
    if (user.site) {
      localStorage.setItem(getSelectedSiteKey(user.email), JSON.stringify(user.site));
    }
  }
};

const broadcastAuthMessage = (payload) => {
  const channel = new BroadcastChannel(APP_MESSAGE_BROADCAST_CHANNEL);
  channel.postMessage(payload);
  channel.close();
};
export const setInitUrl = (url) => {
  return {
    type: INIT_URL,
    payload: url
  };
};

export const userSignUp = ({ email, password, name }) => {
  // console.log(email, password);
  // return (dispatch) => {
  //   dispatch({type: FETCH_START});
  //   axios.post('auth/register', {
  //       email: email,
  //       password: password,
  //       name: name
  //     }
  //   ).then(({data}) => {
  //     console.log("data:", data);
  //     if (data.result) {
  //       localStorage.setItem("token", JSON.stringify(data.token.access_token));
  //       axios.defaults.headers.common['access-token'] = "Bearer " + data.token.access_token;
  //       dispatch({type: FETCH_SUCCESS});
  //       dispatch({type: USER_TOKEN_SET, payload: data.token.access_token});
  //       dispatch({type: USER_DATA, payload: data.user});
  //     } else {
  //       console.log("payload: data.error", data.error);
  //       dispatch({type: FETCH_ERROR, payload: "Network Error"});
  //     }
  //   }).catch(function (error) {
  //     dispatch({type: FETCH_ERROR, payload: error.message});
  //     console.log("Error****:", error.message);
  //   });
  // }
};

export const userSignIn = (email, password) => {
  return (dispatch) => {
    dispatch({ type: SIGNIN_USER_START });
    axios.post('api/auth/signin', {
      email: email,
      password: password,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
    }
    ).then(({ data }) => {      
      const USESSIONID = uuidv1();
      if (data) {
        const storedUser = getStoredAuthContext(data.email);
        const user = {
          ...buildAuthUser(data, false, storedUser),
          authenticated: false,
        }
        persistAuthUserContext(user);
        sessionStorage.setItem("USESSIONID", USESSIONID);
        dispatch({ type: SIGNIN_USER_SUCCESS });
        dispatch({ type: FETCH_SUCCESS });
        dispatch({ type: USER_DATA, payload: user });
        dispatch({ type: GET_SITES_SUCCESS, mips: user.mips });
        // dispatch({ type: FETCH_MODALITY_TYPES });

        const obj = {
          action: NEW_SESSION_CREATED,
          payload: {
            sessionId: USESSIONID
          }
        }
        broadcastAuthMessage(obj);
        navigateTo('/');

      } else {
        dispatch({ type: SIGNIN_USER_ERROR, payload: LOGIN_ERROR });
      }
    }).catch(function (error) {
      // dispatch({ type: FETCH_ERROR, payload: LOGIN_ERROR });
      const errorMsg = getErrorMessage(error);
      if (errorMsg) {
        message.error(errorMsg);
        dispatch({ type: SIGNIN_USER_ERROR, payload: errorMsg });
      } else {
        message.error(LOGIN_ERROR);
        dispatch({ type: SIGNIN_USER_ERROR, payload: LOGIN_ERROR });
      }
    });
  }
};

export const bootstrapAuth = () => {
  return (dispatch) => {
    dispatch({ type: AUTH_BOOTSTRAP_REQUEST });
    axios.get('/api/v1/user/me', { suppressAuthRedirect: true })
      .then(({ data }) => {
        if (data) {
          const USESSIONID = sessionStorage.getItem("USESSIONID") || uuidv1();
          const storedUser = getStoredAuthContext(data.email);
          const user = buildAuthUser(data, true, storedUser);
          persistAuthUserContext(user);
          sessionStorage.setItem("USESSIONID", USESSIONID);
          dispatch({ type: AUTH_BOOTSTRAP_SUCCESS, payload: user });
          dispatch({ type: GET_SITES_SUCCESS, mips: user.mips });
          dispatch({ type: GET_USER_SESSION_DATA, email: user.email });
        } else {
          clearAuthSession();
          dispatch({ type: AUTH_BOOTSTRAP_FAILURE });
        }
      }).catch(function () {
        clearAuthSession();
        dispatch({ type: AUTH_BOOTSTRAP_FAILURE });
      });
  };
};


export const verifyOtp = (payload) => {
  return async (dispatch) => {
    dispatch({ type: VERIFY_OTP_START });
    const response = await verifyOtpAPI(payload);
    if (response.success) {
      dispatch({ type: VERIFY_OTP_SUCCESS });
      dispatch({ type: FETCH_MODALITY_TYPES });
    } else {
      if (response.error) {
        message.error(response.error);
      } else {
        message.error("Failed to verify OTP!");
      }
      dispatch({ type: VERIFY_OTP_ERROR });
    }
  }
}

// export const userSignIn = ({email, password}) => {
//   return (dispatch) => {
//     dispatch({type: FETCH_START});
//     axios.post('auth/login', {
//         email: email,
//         password: password,
//       }
//     ).then(({data}) => {
//       console.log("userSignIn: ", data);
//       if (data.result) {
//         localStorage.setItem("token", JSON.stringify(data.token.access_token));
//         axios.defaults.headers.common['access-token'] = "Bearer " + data.token.access_token;
//         dispatch({type: FETCH_SUCCESS});
//         dispatch({type: USER_TOKEN_SET, payload: data.token.access_token});
//       } else {
//         dispatch({type: FETCH_ERROR, payload: data.error});
//       }
//     }).catch(function (error) {
//       dispatch({type: FETCH_ERROR, payload: error.message});
//       console.log("Error****:", error.message);
//     });
//   }
// };

export const getUser = () => {
  return (dispatch) => {
    dispatch({ type: FETCH_USER_START });
    axios.get('/api/v1/user/me')
      .then(({ data }) => {
        if (data) {          
          const storedUser = getStoredAuthContext(data.email);
          const user = buildAuthUser(data, true, storedUser);
          persistAuthUserContext(user);
          dispatch({ type: FETCH_USER_SUCCESS });
          dispatch({ type: USER_DATA, payload: user });
          dispatch({ type: AUTH_REFRESH_SUCCESS });
        } else {
          dispatch(userSignOut());
          dispatch({ type: FETCH_USER_ERROR });
        }
      }).catch(function (error) {
        dispatch(userSignOut());
        dispatch({ type: FETCH_USER_ERROR });
      });
  }
};



export const authRefresh = (appLoading) => {
  return (dispatch, getState) => {
    const { auth } = getState();
    if (appLoading) {
      dispatch({ type: AUTH_REFRESH_START });
    }
    axios.post('/api/auth/refresh')
      .then(({ data }) => {
        if (!auth.authUser) {
          dispatch(getUser());
        } else {
          dispatch({ type: AUTH_REFRESH_SUCCESS });
          dispatch({ type: GET_USER_SESSION_DATA, email: auth.authUser.email });
        }
      }).catch(function (error) {
        dispatch(userSignOut());
        dispatch({ type: AUTH_REFRESH_ERROR });
      });
  }
};

export const resetReduxStore = () => {
  return (dispatch) => {
    clearAuthSession();
    dispatch({ type: SIGNOUT_USER_SUCCESS });
  }
}

export const userSignOut = () => {
  return (dispatch, getState) => {
    const { auth } = getState();

    // Optimization: If no user is logged in, skip the API call but clear state to stop spinner
    if (!auth || !auth.authUser) {
      clearAuthSession();
      sessionStorage.removeItem("user");
      sessionStorage.removeItem("mips");
      sessionStorage.removeItem("modalityTypes");
      sessionStorage.removeItem("USESSIONID");
      sessionStorage.removeItem("pacsSessionId");
      dispatch({ type: SIGNOUT_USER_SUCCESS });
      return;
    }

    dispatch({ type: SIGNOUT_USER_START });
    axios({
      method: 'post',
      url: '/api/auth/signout',
      suppressAuthRedirect: true
    })
      .then(({ data }) => {
        clearAuthSession(auth.authUser);
        broadcastAuthMessage({ action: AUTH_LOGOUT });
        // dispatch({ type: CLOSE_SESSION });
        dispatch({ type: SIGNOUT_USER_SUCCESS });
      }).catch(function (error) {
        clearAuthSession(auth.authUser);
        broadcastAuthMessage({ action: AUTH_LOGOUT });
        dispatch({ type: SIGNOUT_USER_ERROR });
      });
  }
};

export const setUserRole = (role) => {
  return (dispatch, getState) => {
    const { auth } = getState();
    if (auth?.authUser?.email && role) {
      persistAuthUserContext({ ...auth.authUser, role });
    }
    dispatch({ type: SET_USER_ROLE, role });
    dispatch(fetchUserAllowedRisWithMips(role));
    navigateTo({
      pathname: role ? '/' : '/user-role-selection',
    });
  }
}

export const setUserSite = (site) => {
  return (dispatch, getState) => {
    const { auth } = getState();
    if (auth?.authUser?.email && site) {
      persistAuthUserContext({ ...auth.authUser, site });
    }
    dispatch({ type: SET_USER_SITE, site });
    // store in session storage also
    let user = JSON.parse(sessionStorage.getItem("user")) || {};
    user.site = site;
    sessionStorage.setItem("user", JSON.stringify(user));
  };
};

export const fetchUserAllowedRisWithMips = (sessionRole) => {
  return async (dispatch, getState) => {
    const response = await getUserAllowedRisWithMipsAPI(sessionRole);
    if (response && response.success) {
      const { auth } = getState();
      if (auth?.authUser) {
        persistAuthUserContext({ ...auth.authUser, risWithMips: response.risWithMips || [] });
      }
      dispatch({
        type: FETCH_USER_ALLOWED_RIS_WITH_MIPS_SUCCESS,
        risWithMips: response.risWithMips
      });
    } else {
      dispatch({
        type: FETCH_USER_ALLOWED_RIS_WITH_MIPS_ERROR
      })
    }
  }
}

export const updateMipData = (payload) => {
  return {
    type: UPDATE_MIP_DATA,
    payload: payload
  }
}
